import { datadogRum } from "@datadog/browser-rum";
import isbot from "isbot";
import { UserProfile } from "@auth0/nextjs-auth0/client";

import pkg from "../../package.json";
import isSSR from "../utils/isSSR";

let isInitialized = false;

export default function useDataDog(user: UserProfile = {}) {
  const ssr = isSSR();
  if (!isInitialized && !ssr && process.env.NEXT_PUBLIC_DEPLOY_ENV) {
    isInitialized = true;

    if (
      !process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID ||
      !process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN
    ) {
      console.error("Missing Datadog application ID or client token");
      return;
    }

    datadogRum.init({
      applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
      clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
      site: "datadoghq.com",
      service: "wholesale.auction.ui",
      env: process.env.NEXT_PUBLIC_DEPLOY_ENV,
      version: pkg.version,
      defaultPrivacyLevel: "mask-user-input",
      sessionSampleRate: isbot(navigator.userAgent) ? 0 : 100,
      sessionReplaySampleRate: 50,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      beforeSend: (event) => {
        event.context = {
          ...event.context,
          mfe: event.context?.mfe || "unknown",
          userId: user.sub,
        };
        return true;
      },
    });

    if (user.sub) {
      datadogRum.setUser({
        id: user.sub,
        name: user.name ?? undefined,
        email: user.email ?? undefined,
        representativeId: user.representativeId,
      });
    }

    datadogRum.startSessionReplayRecording();
  }
}
